import Storage from '@comm/utils/storagehandle'
const state = {
  eventType: Storage.getItem('eventType') || null,
  eventInfo: Storage.getItem('eventInfo') || null,
  activeMenu: Storage.getItem('activeMenu') || 0,
//   miniCode: Storage.getItem('miniCode') || null
}

const getters = {
  eventInfo: state => state.eventInfo,
  activeMenu: state => state.activeMenu,
  eventType: state => state.eventType,
}

const actions = {

}

const mutations = {
  EVENT_CHANGE_EVENT_INFO (state, data) {
    state.eventInfo = data
    Storage.setItem(`eventInfo`, state.eventInfo)
  },
  EVENT_CHANGE_ACTIVE_MENU (state, data) {
    state.activeMenu = data
    Storage.setItem(`activeMenu`, state.activeMenu)
  },
  EVENT_CHANGE_EVENT_TYPE (state, data) {
    state.eventType = data
    Storage.setItem(`eventType`, state.eventType)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/district/store/modules/event.js